module.exports = __webpack_public_path__ + "static/media/orange-triangle.d975a7c5.svg";